import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {CurrencyKindModel} from "./CurrencyKindModel";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class Currency extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(Currency, v) : SKIP;
            },
            (v) => {
                return deserialize(Currency, v) || new Currency();
            }
        );
    }

    constructor(kind = null, amount = 0) {
        super();
        this._kind = kind;
        this._amount = amount;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    valid() {

        if (!CurrencyKindModel.is(this.kind)) {
            return false;
        }

        if (!Number.isInteger(this.amount) || this.amount < 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.kind || this.amount < 0;
    }

    free() {
        return this.amount === 0;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Currency());
        } else if (target instanceof Currency) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Currency, {
    _kind: alias("kind", CurrencyKindModel.schema()),
    _amount: alias("amount", Schema.primitive())
});

// _kind: alias("kind", reference("id", (id, cb) => {
//     return cb(null, CurrencyKind.getValue(id));
// }, {
//     beforeDeserialize: function (callback, value, parentValue) {
//         if (parentValue["type"] && !parentValue["kind"]) {
//             callback(null, parentValue["type"])
//         } else {
//             callback(null, value)
//         }
//     }
// })),